module.exports = __webpack_public_path__ + "img/descendents.17c2682f.jpg";